import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VplaybookAudioPlayerComponent } from '../../components/vplaybook-audio-player/vplaybook-audio-player.component';

@NgModule({
  exports: [
    VplaybookAudioPlayerComponent
  ],
  declarations: [
    VplaybookAudioPlayerComponent
  ],
  imports: [
    CommonModule
  ]
})
export class VplaybookAudioPLayerModule { }
